// Client\client-vite\src\components\Navbars\PublicNavbar.tsx
import * as React from "react"

import { CircleCheckIcon, CircleHelpIcon, CircleIcon } from "lucide-react"

import {
    NavigationMenu,
    NavigationMenuContent,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger,
} from "@/components/ui/navigation-menu"
import { Link } from "react-router-dom"

import { SidebarTrigger } from "../ui/sidebar"
import { cookie, COOKIE_KEYS } from "@/lib/cookies"



const components: { title: string; to: string; description: string }[] = [
    {
        title: "Home",
        to: "/",
        description: "Return to the main IDSCRM homepage and platform overview.",
    },
  
    {
        title: "Dealers",
        to: "/dealer",
        description: "Manage your dealership inventory, staff, and sales pipeline.",
    },
    {
        title: "Customers",
        to: "/customer",
        description: "Access customer profiles, credit apps, and communication logs.",
    },
    {
        title: "Auctions",
        to: "/auctions",
        description: "Join live dealer-to-dealer auctions or stream your inventory.",
    },
    {
        title: "BDC",
        to: "/bdc",
        description: "Manage your dealership inventory, staff, and sales pipeline.",
    },
    {
        title: "Finance",
        to: "/finance",
        description: "Finance Managers at your dealership  approvals, stipulations, and warranty sales pipeline.",
    },
    {
        title: "Sales",
        to: "/sales",
        description: "Sales Team at your dealership  opportunities, notes, appointments, and more for the car sales pipeline.",
    },
    {
        title: "Parts",
        to: "/parts",
        description: "Join the automtive ecosystem at your delaership our exteranally serving customer and the autmotive industry here.",
    },
    {
        title: "Insurance",
        to: "/insurance",
        description: "Easily bind receive quote request deliver coverage and provide instant access to car selling ecosystem",
    },
    {
        title: "Auctions",
        to: "/auction",
        description: "Dealer network and public auctions to get great deals and obtain new inventory",
    },
    {
        title: "Lenders",
        to: "/lenders",
        description: "Analyst for automotive loans and approvals and creditapplication approvals",
    },
    {
        title: "MarketPlaces",
        to: "/marketplaces",
        description: "Explore AutoCityMag, WeFinanceHere, and BuyHerePayHereUS.",
    },
    {
        title: "Integrations",
        to: "/integrations",
        description: "Connect your DMS, CRM, warranty, and finance tools easily.",
    },
    {
        title: "transport",
        to: "/transport",
        description: "Offer or manage vehicle transport and deliveries from within the eco network.",
    },
    {
        title: "Warranty",
        to: "/warranty",
        description: "Sell and manage warranty plans for new and used vehicles.",
    },
    {
        title: "Salvage",
        to: "/Salvage",
        description: "Sell and manage parts from collision vehicles through eco network",
    },
    {
        title: "Service",
        to: "/service",
        description: "Service Industry at delership or externally",
    },
    {
        title: "Collision",
        to: "/collision",
        description: "Service vehicles through collision and body repair",
    },
    {
        title: "News",
        to: "/news",
        description: "Stay informed with industry and IDSCRM ecosystem updates.",
    },
    {
        title: "Blog",
        to: "/blog",
        description: "Read stories, tutorials, and platform insights from IDSCRM.",
    },
    {
        title: "Video",
        to: "/video",
        description: "Watch live demos, broadcasts, and walkthrough tutorials.",
    },
]


const marketplaces = [
    {
        name: "AutoCityMag.com",
        to: "/marketplaces/autocitymag",
        description:
            "Shop for your next vehicle and find the best program for you in your local area.",
        features: [
            { title: "Overview", text: "The best place to sell/trade your car and buy a new one for life." },
            { title: "Dealers", text: "Manage your inventory and car deals for your dealership." },
            { title: "Listings", text: "List cars for sale and connect with buyers instantly." },
        ],
    },
    {
        name: "WeFinanceHere.com",
        to: "/marketplaces/wefinancehere",
        description:
            "Dealer-to-dealer network connecting inventory across platforms.",
        features: [
            { title: "Wholesale", text: "Access dealer-only auctions and wholesale listings." },
            { title: "Broadcasts", text: "Stream and view live inventory broadcasts." },
            { title: "Analytics", text: "Real-time analytics and pricing optimization." },
        ],
    },
    {
        name: "BuyHerePayHereUs",
        to: "/marketplaces/buyherepayhereus",
        description:
            "Live and online dealer auction integrations across North America.",
        features: [
            { title: "Live Auctions", text: "Bid in real-time on live auction feeds." },
            { title: "Post & Sell", text: "Easily post cars to multiple auction sites at once." },
            { title: "Eco Sync", text: "Automatic Eco spec syncing." },
        ],
    },
    {
        name: "Africars.app",
        to: "/marketplaces/africars.app",
        description:
            "Live and online dealer auction integrations across North America.",
        features: [
            { title: "Live Auctions", text: "Find vehicles locally internatinal access to inventory" },
            { title: "Post & Sell", text: "Easily post cars to multiple auction sites at once." },
            { title: "Eco Sync", text: "Automatic Eco spec syncing." },
        ],
    },
]

export const PublicNavbar = () => {
    
    const [sidebarOpen, setSidebarOpen] = React.useState<boolean>(false)

    // const cookieStore = await cookies()
    // const defaultOpen = cookieStore.get("sidebar_state")?.value === "true";

    // Seed from cookie on mount
    React.useEffect(() => {
        setSidebarOpen(cookie.getBool(COOKIE_KEYS.SIDEBAR_STATE))
    }, [])

    const handleSidebarToggle = () => {
        const next = !sidebarOpen
        setSidebarOpen(next)
        cookie.setBool(COOKIE_KEYS.SIDEBAR_STATE, next)
    }

    return (
        <div className="w-full bg-background border-b">
            <nav className="w-full flex items-center justify-between px-4 py-4">

                {/* LEFT */}
                <div>
                    {/* CollapseButtons */}
                    <SidebarTrigger onClick={handleSidebarToggle} />
                </div>
                       
                {/* CENTER MENU */}
                <div className="flex-1 flex justify-center">
                    <NavigationMenu viewport={false} className="w-auto">
                        <NavigationMenuList className="flex gap-6">
                                <NavigationMenuItem>
                                    <NavigationMenuTrigger>Home</NavigationMenuTrigger>
                                    <NavigationMenuContent>
                                        <div>
                                            <ul className="grid gap-2 md:w-[400px] lg:w-[500px] lg:grid-cols-[.75fr_1fr]">
                                                <li className="row-span-3">
                                                    <NavigationMenuLink asChild>
                                                        <Link
                                                            className="from-muted/50 to-muted flex h-full w-full flex-col justify-end rounded-md bg-linear-to-b p-6 no-underline outline-hidden select-none focus:shadow-md"
                                                            to="/"
                                                        >
                                                            <div className="mt-4 mb-2 text-lg font-medium">
                                                               IDScrm
                                                            </div>
                                                            <p className="text-muted-foreground text-sm leading-tight">
                                                                Home Page
                                                            </p>
                                                        </Link>
                                                    </NavigationMenuLink>
                                                </li>
                                                <ListItem to="/dealer" title="Dealers">
                                                    Re-usable components built using Radix UI and Tailwind CSS.
                                                </ListItem>
                                                <ListItem to="/sales" title="Sales">
                                                    How to install dependencies and structure your app.
                                                </ListItem>
                                                <ListItem to="/warranty" title="Warranty">
                                                    Styles for headings, paragraphs, lists...etc
                                                </ListItem>
                                            </ul>
                                        </div>
                                        
                                    </NavigationMenuContent>
                                </NavigationMenuItem>
                                


                            <NavigationMenuItem>
                                <NavigationMenuTrigger>Market Places</NavigationMenuTrigger>
                                <NavigationMenuContent>
                                    <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 w-[700px] p-4">
                                        {marketplaces.map((mp) => (
                                            <li
                                                key={mp.name}
                                                className="flex flex-col justify-between rounded-lg border p-4 bg-card hover:bg-accent/50 transition"
                                            >
                                                {/* Header */}
                                                <div>
                                                    <Link
                                                        to={mp.to}
                                                        className="no-underline hover:underline font-semibold text-base"
                                                    >
                                                        {mp.name}
                                                    </Link>
                                                    <p className="text-muted-foreground text-sm mt-1 line-clamp-2">
                                                        {mp.description}
                                                    </p>
                                                </div>

                                                {/* Feature list (compact version) */}
                                                <ul className="mt-3 space-y-1 text-xs text-muted-foreground">
                                                    {mp.features.map((feat) => (
                                                        <li key={feat.title}>
                                                            <span className="font-medium text-foreground">{feat.title}:</span>{" "}
                                                            {feat.text}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        ))}
                                    </ul>
                                </NavigationMenuContent>
                            </NavigationMenuItem>


                              



                                


                                <NavigationMenuItem>
                                    <NavigationMenuTrigger>Eco CRM Products</NavigationMenuTrigger>
                                    <NavigationMenuContent>
                                        <ul className="grid w-[400px] gap-2 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
                                            {components.map((component) => (
                                                <ListItem
                                                    key={component.title}
                                                    title={component.title}
                                                    to={component.to}
                                                >
                                                    {component.description}
                                                </ListItem>
                                            ))}
                                        </ul>
                                    </NavigationMenuContent>
                                </NavigationMenuItem>







                               
                                <NavigationMenuItem>
                                    <NavigationMenuTrigger>Dashboards</NavigationMenuTrigger>
                                    <NavigationMenuContent>
                                        <ul className="grid w-[200px] gap-4">
                                            <li>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/admin/dashboard">Admin Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/assistant/dashboard">Assistant Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/bdc/dashboard">BDC Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/customer/portal">Customer Portal</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/dealer/dashboard">Dealers Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/finance/dashboard">Finance Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/sales/dashboard">Sales Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/parts/dashboard">Parts Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/insurance/dashboard">Insurance Dashboard</Link>
                                                </NavigationMenuLink>
                                                
                                                <NavigationMenuLink asChild>
                                                    <Link to="/auctions/dashboard">Auction Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/lenders/dashboard">Lenders Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/transport/dashboard">Transport Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/warranty/dashboard">Warranty Dashboard</Link>
                                                </NavigationMenuLink>
                                              
                                                <NavigationMenuLink asChild>
                                                    <Link to="/salvage/dashboard">Salvage Dashboard</Link>
                                                </NavigationMenuLink>
                                               
                                                <NavigationMenuLink asChild>
                                                    <Link to="/service/dashboard">Service Dashboard</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/collision/dashboard">Body Collision Dashboard</Link>
                                                </NavigationMenuLink>
                                            </li>
                                        </ul>
                                    </NavigationMenuContent>
                                </NavigationMenuItem>


                                <NavigationMenuItem>
                                    <NavigationMenuTrigger>Logins</NavigationMenuTrigger>
                                    <NavigationMenuContent>
                                        <ul className="grid w-[200px] gap-4">
                                            <li>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/admin/login">Admin Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/assistant/login">Assistant Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/bdc/login">BDC Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/customer/login">Customer Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/dealer/login">Dealers Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/finance/login">Finance Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/sales/login">Sales Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/parts/login">Parts Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/insurance/login">Insurance Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/auctions/login">Auction Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/lenders/login">Lenders Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/transport/login">Transport Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/warranty/login">Warranty Login</Link>
                                                </NavigationMenuLink>

                                                <NavigationMenuLink asChild>
                                                    <Link to="/salvage/login">Salvage Login</Link>
                                                </NavigationMenuLink>
                                                
                                                <NavigationMenuLink asChild>
                                                    <Link to="/service/login">Service Login</Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/collision/login">Body Collision Login</Link>
                                                </NavigationMenuLink>
                                            </li>
                                        </ul>
                                    </NavigationMenuContent>
                                </NavigationMenuItem>


                                <NavigationMenuItem>
                                    <NavigationMenuTrigger>Contact</NavigationMenuTrigger>
                                    <NavigationMenuContent>
                                        <ul className="grid w-[200px] gap-4">
                                            <li>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/about" className="flex-row items-center gap-2">
                                                        <CircleHelpIcon />
                                                        About Us
                                                    </Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/mission" className="flex-row items-center gap-2">
                                                        <CircleIcon />
                                                        Our Mission
                                                    </Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/careers" className="flex-row items-center gap-2">
                                                        <CircleCheckIcon />
                                                        Careers
                                                    </Link>
                                                </NavigationMenuLink>
                                                <NavigationMenuLink asChild>
                                                    <Link to="/contact" className="flex-row items-center gap-2">
                                                        <CircleCheckIcon />
                                                        Contact Us
                                                    </Link>
                                                </NavigationMenuLink>
                                            </li>
                                        </ul>
                                    </NavigationMenuContent>
                                </NavigationMenuItem>

                        </NavigationMenuList>
                    </NavigationMenu>
                </div>

                
                

            </nav>
        </div>
    )
}

function ListItem({
    title,
    children,
    to,
    ...props
}: React.ComponentPropsWithoutRef<"li"> & { to: string }) {
    return (
        <li {...props}>
            <NavigationMenuLink asChild>
                <Link to={to}>
                    <div className="text-sm leading-none font-medium">{title}</div>
                    <p className="text-muted-foreground line-clamp-2 text-sm leading-snug">
                        {children}
                    </p>
                </Link>
            </NavigationMenuLink>
        </li>
    )
}


export default PublicNavbar